// 角色管理
import http from "@/jslibs/axios/http";

// 新增角色
export const add = (data) => http.post("/v1/cms/AdminAuthGroup", data);

// 修改角色
export const edit = ({ uuid, ...data }) => http.put(`/v1/cms/AdminAuthGroup/${uuid}`, data);

// 删除角色
export const del = ({ id }) => http.delete(`/v1/cms/AdminAuthGroup/${id}`);

// 角色详情
export const detail = ({ uuid, ...data }) => http.get(`/v1/cms/AdminAuthGroup/${uuid}`, data);

// 角色列表
export const list = (data) => http.get("/v1/cms/AdminAuthGroup", data);